import React from 'react';
import { Link } from 'react-router-dom';
import {
  ATMModal,
  ATMHeader,
  ATMIcon,
  ATMButton,
  ATMDropdown,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IFireDispatch } from 'src/models/fire-dispatch.model';
import DispatchStatus from 'src/components/atoms/fire-dispatch-status/fire-dispatch-status.component';
import FireDispatchEmailNotification from '../../fire-dispatch-list/fire-dispatch-email-notification/fire-dispatch-email-notification.component';
import styles from '../fire-dispatch-details.module.scss';

interface IProps {
  dispatchId?: number;
  status?: string | null;
  data?: IFireDispatch;
}

const FireDispatchDetailsHeader: React.FC<IProps> = ({
  dispatchId,
  status,
  data,
}) => {
  const options = [
    {
      key: 'edit',
      icon: 'edit',
      text: 'Edit Status/ Details ',
      value: 'edit',
    },
    {
      key: 'send',
      icon: 'mail outline',
      text: 'Send Notification ',
      value: 'send',
    },
  ];

  return (
    <ATMModal.Header className={styles.header}>
      <div className={styles.flex}>
        <ATMIcon name="fire extinguisher" circular />
        <ATMHeader as="h1" className={styles.ticketText}>
          {`${Lang.LBL_TICKET_NO} ${dispatchId}`}
        </ATMHeader>
        <DispatchStatus dispatchStatus={status ?? undefined} />
      </div>
      <ATMButton
        secondary
        icon="edit"
        as={Link}
        to={`/dispatch/${dispatchId}/edit`}
        className={styles.smallMarginRight}
        content="Edit Status/Details"
      />
      {data && <FireDispatchEmailNotification data={data} secondary />}
      <ATMButton.Group className="sempraSmallMarginBottom">
        <ATMDropdown
          text="Actions"
          className="button secondary icon dropdownBtn"
          direction="right"
          size="mini"
          options={options}
        />
      </ATMButton.Group>
    </ATMModal.Header>
  );
};

export default FireDispatchDetailsHeader;
